<template>
    <div>序达首页</div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
    
})
</script>